import React, { useMemo } from 'react'
import { Button, type GridColumns } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/collections/utils/domain/intl'
import { type CollectionDatum } from 'domains/collections/types/collections.types'
import { CollectionsListContentCell } from 'domains/collections/components/collections-list/components/content-cell/CollectionsListContentCell'

interface Props {
  onSelect: (collection: CollectionDatum) => void
}

export const useSelectCollectionModalColumns = ({ onSelect }: Props) => {
  const messages = useDomainMessages({
    name: 'collectionsDomain.list.columns.name.header',
    content: 'collectionsDomain.list.columns.content.header',
    add: 'collectionsDomain.add',
  })

  const columns = useMemo(() => {
    const columns: GridColumns<CollectionDatum> = [
      {
        id: 'name',
        Header: messages.name,
        Cell: ({ row }) => row.original.name,
      },
      {
        id: 'content',
        Header: messages.content,
        Cell: ({ row }) => <CollectionsListContentCell collection={row.original} />,
      },
      {
        id: 'actions',
        Cell: ({ row }) => <Button onClick={() => onSelect(row.original)}>{messages.add}</Button>,
        width: 50,
      },
    ]

    return columns
  }, [messages, onSelect])

  return columns
}
